import {
  DestroyRef,
  DOCUMENT,
  inject,
  makeEnvironmentProviders,
  provideEnvironmentInitializer,
} from '@angular/core';

export function provideTouchTapDelivery() {
  return makeEnvironmentProviders([
    provideEnvironmentInitializer(() => {
      const controller = new AbortController();
      inject(DOCUMENT).addEventListener('touchstart', () => undefined, {
        passive: true,
        signal: controller.signal,
      });
      inject(DestroyRef).onDestroy(() => controller.abort());
    }),
  ]);
}
